export default {"src":"/_next/static/media/cocktail.df62eb21.svg","height":22,"width":19,"blurWidth":0,"blurHeight":0};